import { render, staticRenderFns } from "./AlertComponentTop.vue?vue&type=template&id=16edc385&scoped=true&"
import script from "./AlertComponentTop.vue?vue&type=script&lang=ts&"
export * from "./AlertComponentTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edc385",
  null
  
)

export default component.exports